export default __webpack_public_path__ + "static/ios-case-4-03b8c5b15f7d96446c2bfc7f5b814c80.webp";